import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Filters } from '../Filters';
import type { FilterState } from '../Filters';

interface CollapsibleFiltersProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
}

export function CollapsibleFilters({ filters, onFilterChange }: CollapsibleFiltersProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full px-4 py-3 flex items-center justify-between text-slate hover:bg-gray-50 transition-colors rounded-lg"
      >
        <span className="text-sm font-medium">Customize your letter</span>
        {isExpanded ? (
          <ChevronUp className="h-4 w-4" />
        ) : (
          <ChevronDown className="h-4 w-4" />
        )}
      </button>
      
      {isExpanded && (
        <div className="px-4 pb-4">
          <Filters filters={filters} onFilterChange={onFilterChange} />
        </div>
      )}
    </div>
  );
}